import classNames from 'classnames';

import { AlignmentMark } from '@/components/SiteFooter/AlignmentMark';

interface CornerCropMarkProps {
  alignmentClassNames?: string;
  side: 'left' | 'right';
}

export function CornerCropMark({
  side,
  alignmentClassNames,
}: CornerCropMarkProps) {
  return (
    <div className={classNames('text-gray-600 w-8 h-8', alignmentClassNames)}>
      {/* Vertical Bar */}
      <div
        className={classNames('bg-current w-px h-5 absolute bottom-0', {
          'right-0': side === 'left',
          'left-0': side === 'right',
        })}
      />

      {/* Circular Alignment Icon */}
      <AlignmentMark
        className={classNames('absolute fill-current bottom-half', {
          'left-half': side === 'left',
          'right-half': side === 'right',
        })}
      />
    </div>
  );
}
